import DesktopUpload from './DesktopUpload';

export default DesktopUpload;
